import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/ui/PageHeader";
import { CharacterForm } from "@/features/characters/components/CharacterForm";
import { useCharacters } from "@/features/characters/hooks/useCharacters";
import type { CharacterInput } from "@/features/characters/types";

export function CharacterCreatePage() {
  const navigate = useNavigate();
  const { createCharacter } = useCharacters();

  async function handleSubmit(value: CharacterInput) {
    const character = await createCharacter(value);
    navigate(`/characters/${character.id}`);
  }

  return (
    <div className="grid gap-8">
      <PageHeader
        eyebrow="Nova ficha"
        title="Crie um novo personagem"
        description="Preencha os dados base da ficha, registre a identidade do herói e deixe a estrutura pronta para regras mais avançadas nas próximas etapas."
      />
      <CharacterForm submitLabel="Salvar personagem" onSubmit={handleSubmit} />
    </div>
  );
}
